import { render, staticRenderFns } from "./Breach.vue?vue&type=template&id=6f67f150&"
import script from "./Breach.vue?vue&type=script&lang=js&"
export * from "./Breach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports